import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import IconFilter from '../../assets/icons/filter.svg';
import LightThemeIconFilter from '../../assets/icons/filter-dark.svg';
import styles from './Filters.module.scss';
import { MobileFilters } from './MobileFilters';
import useWindowSize from "../../utils/useWindowSize";
import { buildUrl } from 'utils/helpers';

const Filters = (props) => {
  const {
    sites,
    filterOptions,
    isSearchable,
    isRtl,
    setFilter,
    resetFilters,
    selectedFilters,
    useSiteAsFilter,
    colorScheme,
    homeURL
  } = props;

  const { width } = useWindowSize();

  const groupedFilters = [ 'attrs', 'genre', 'rating', 'other' ];
  const isMoviesFilterDisabled = false;
  const isGroupFilterDisabled = false;
  
  // set default value if there are pre-defined filters
  let groupedFiltersDefaultValue = '';
  Object.keys(selectedFilters).forEach(filter => {
    if (filter !== 'cinema' && filter !== 'site' && !groupedFiltersDefaultValue && selectedFilters[filter] && selectedFilters[filter].length) {
      groupedFiltersDefaultValue = {
        label: selectedFilters[filter][0],
        value: selectedFilters[filter][0],
        filter: 'attrs',
      };
    }
  });
  
  const [areFilterVisible, setAreFilterVisible] = useState(false);
  const [filterGroupOptions, setFilterGroupOptions] = useState([]);
  const [activeMobileFilterScreen, setАctiveMobileFilterScreen] = useState('');

  useEffect(() => {
    let groupedOptions = [{
      label: 'All',
      value: 'all'
    }];
    
    Object.keys(filterOptions).forEach(filter => {
      if (filter !== 'movies') { // skip movies filter
        groupedOptions.push({
          label: filter === 'attrs' ? window.mapiTranslations['Screening type'] : filter,
          options: filterOptions[filter]
        });

        // show filters
        if (useSiteAsFilter === '1' && width > 1024 && !areFilterVisible) {
          setAreFilterVisible(true);
        }
      }
    });

    setFilterGroupOptions(groupedOptions);
  }, [filterOptions]);

  const handleChange = ( selectedOption, e ) => {
    if (e.action === 'clear') {
      if (e.name === 'filter-group') {
        // group filter
        groupedFilters.forEach(function (filterName, index) {
          // clear the already selected filters
          if (selectedFilters[filterName].length > 0) {
            resetFilters(filterName);
          }
        });
      } else {
        setFilter(e.name, [], 'replace');
      }
    } else {
      if (e.name === 'filter-group') {
        // multi select case
        if (Array.isArray(selectedOption)) {
          // clear the already selected filters
          groupedFilters.forEach(function (filterName, index) {
            if (!selectedOption.filter || selectedFilters[filterName].length > 0) {
              resetFilters(filterName);
            }
          });

          const isAllSected = selectedOption.filter(item => item.value === 'all').length;

          // apply filters if the "All" option is not selected
          if (!isAllSected) {
            const filtersToApply = {};

            // collect grouped filters data
            selectedOption.forEach(function (option, index) {
              if (!filtersToApply[option.filter]) {
                filtersToApply[option.filter] = [option.value];
              } else {
                filtersToApply[option.filter].push(option.value);
              }
            });

            // apply the filters
            Object.keys(filtersToApply).forEach(filter => {
              setFilter(filter, filtersToApply[filter], 'replace');
            });
          }
        } else if ( selectedOption === null && e.action === 'remove-value' ) { // clear the last group filter by his own button
          resetFilters(e.removedValue.filter);
        } else { // single option select case
          // clear the already selected filters
          groupedFilters.forEach(function (filterName, index) {
            if (!selectedOption.filter || selectedFilters[filterName].length > 0) {
              resetFilters(filterName);
            }
          });
          
          // set the new filter value
          if (selectedOption.filter) {
            setFilter(selectedOption.filter, [selectedOption.value], 'replace');
          }
        }
      } else {
        setFilter(selectedOption.filter, [selectedOption.value], 'replace');
      }
    }
  };

  const toggleFilters = (e) => {
    e.preventDefault();
    setAreFilterVisible(!areFilterVisible);
  }

  const mobileFilters = [
    {
      value: 'attrs',
      label: window.mapiTranslations['Showing in']
    },
    {
      value: 'rating',
      label: window.mapiTranslations['Age']
    },
    {
      value: 'genre',
      label: window.mapiTranslations['Genres']
    },
    {
      value: 'other',
      label: window.mapiTranslations['Other']
    }
  ];

  const handleInfoFilterClick = (e) => {
    e.preventDefault();

    setАctiveMobileFilterScreen( e.target.getAttribute('data-screen') );

    if (!areFilterVisible) {
      setAreFilterVisible(true);
    }
  }

  const selectedCinemaName = sites.filter(item => item.id === selectedFilters.cinema[0]);
  const showSelectedCinema = useSiteAsFilter === '1' && selectedCinemaName.length;

  return (
    <div className={styles.browserHeader}>
      <div className={styles.headerInner}>
        <button className={styles.buttonFilter} type="button" onClick={toggleFilters}>
          <img src={buildUrl([homeURL, (colorScheme === 'light' ? LightThemeIconFilter : IconFilter)])} className={styles.iconFilters} alt="" />
        </button>

        <div className={styles.activeFilters}>
          <ul>
            {
              mobileFilters.map(filterEntry => {
                if (selectedFilters[ filterEntry.value ].length) {
                  let filterText = selectedFilters[ filterEntry.value ].slice(0, 2).join(', ');

                  if (selectedFilters[ filterEntry.value ].length > 2) {
                    filterText += '...';
                  }

                  return (
                    <li key={filterEntry.value}>
                      <button type="button" className={styles.buttonFilter} data-screen={filterEntry.label} onClick={handleInfoFilterClick}>{filterEntry.label}</button>: {filterText}
                    </li>
                  );
                }

                return null;
              })
            }
          </ul>
        </div>
      </div>

      {showSelectedCinema === 1 &&
        <div className={styles.selectedCinema}><span>{window.mapiTranslations['Selected cinema']}:</span> {selectedCinemaName[0].name}</div>
      }

      {width > 1024 &&
        <div className={styles.filtersWrapper + (areFilterVisible ? '' : ' hidden')}>
          <Select
            className="basic-single"
            classNamePrefix="select"
            defaultValue=""
            isClearable={true}
            isDisabled={isMoviesFilterDisabled}
            isLoading={false}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name="movie"
            options={filterOptions.movies}
            onChange={handleChange}
            placeholder={window.mapiTranslations['Select a movie']}
          />

          <Select
            className="basic-single"
            classNamePrefix="select"
            defaultValue={groupedFiltersDefaultValue}
            isMulti
            isClearable={true}
            isDisabled={isGroupFilterDisabled}
            isLoading={false}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name="filter-group"
            options={filterGroupOptions}
            onChange={handleChange}
            placeholder={window.mapiTranslations['Select a filter']}
          />
        </div>
      }

      {width <= 1024 &&
        <MobileFilters 
          areFilterVisible={areFilterVisible} 
          setAreFilterVisible={setAreFilterVisible}
          filterOptions={filterOptions}
          setFilter={setFilter}
          resetFilters={resetFilters}
          selectedFilters={selectedFilters}
          activeMobileFilterScreen={activeMobileFilterScreen}
          colorScheme={colorScheme}
        />
      }
    </div>
  );
}

export { Filters }
